import { locale } from "moment"
import { useMemo } from "react"
import { useState, useEffect } from "react"
import { useSelector } from "react-redux"

export const usePasswordValidate = (v = "") => {
    const [isValid, setIsValid] = useState(false)
    const { locale } = useSelector(state => state.main)
    const validators = useMemo(() => checks(v, locale), [v, locale])

    useEffect(() => {
        // check if all checks are passing
        setIsValid(Object.values(validators).every((rule) => rule.valid))
    }, [v])

    return {
        isPasswordValid: isValid,
        validators
    }
}

const checks = (value, locale) => ({
    minLength: {
        valid: value.length >= 8,
        message: locale.common.passwordLength,
    },
    specialChar: {
        valid: /[~`¿¡!#$%\^&*€£@+÷=\-\[\]\\';,/{}\(\)|\\":<>\?\.\_]/g.test(value),
        message: locale.common.passwordSpecialChar,
    },
    number: {
        valid: /\d/g.test(value),
        message: locale.common.passwordNumber,
    },
    capital: {
        valid: (() => {
            var i = 0
            if (value.length === 0) {
                return false
            }
            while (i < value.length) {
                const character = value.charAt(i)
                if (character == character.toLowerCase()) {
                    // Character is lowercase, numeric, or a symbol
                } else if (character == character.toUpperCase()) {
                    return true
                }
                i++
            }
            return false
        })(),
        message: locale.common.passwordCapital,
    },
    lowercaseLetter: {
        valid: /[a-z]/g.test(value),
        message: locale.common.passwordLetter,
    },
})